import React, { FC } from 'react';
import Dropdown, { MenuItem, ChevronDown, Check } from './styles';
import { Props } from './types';

const Select: FC<Props> = ({
  options,
  currentValue,
  handleChange,
  ...props
}) => {
  return (
    <Dropdown
      IconComponent={ChevronDown}
      value={currentValue}
      onChange={handleChange}
      MenuProps={{
        getContentAnchorEl: null,
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
        transformOrigin: { vertical: 'top', horizontal: 'center' },
        disablePortal: true,
      }}
      {...props}
    >
      {options &&
        options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label} <Check />
          </MenuItem>
        ))}
    </Dropdown>
  );
};

export default Select;
